import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ExpenseTypeActions } from './expense-type.actions';
import { catchError, map, mergeMap, of } from 'rxjs';
import { ExpenseTypeService } from '@core/services/expense-type.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ExpenseTypeEffects {
  private actions$ = inject(Actions);
  private expenseTypeService = inject(ExpenseTypeService);
  private translateService = inject(TranslateService);

  getExpenseTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ExpenseTypeActions.loadExpenseTypes),
      mergeMap((data) =>
        this.expenseTypeService.getExpenseTypes(data).pipe(
          map((response) =>
            ExpenseTypeActions.loadExpenseTypesSuccess(response)
          ),
          catchError((error) =>
            of(
              ExpenseTypeActions.loadExpenseTypesFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );

  addExpenseType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ExpenseTypeActions.addEditExpenseType),
      mergeMap((data) =>
        this.expenseTypeService.addExpenseType(data).pipe(
          map((response) => {
            if (response.success) {
              return data.id
                ? ExpenseTypeActions.updateExpenseTypeSuccess(response)
                : ExpenseTypeActions.addExpenseTypeSuccess(response);
            }
            return ExpenseTypeActions.addExpenseTypeFailure(response);
          }),
          catchError((error) =>
            of(
              ExpenseTypeActions.addExpenseTypeFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );
}
